import React, { Fragment } from 'react';
import { PageLink } from 'src/components/links';
import { OGOnlyWrapper } from 'src/components/hibana';
import styles from './User.module.scss';

const User = ({ email, name, username }) => {
  return (
    <Fragment>
      <div className={styles.Name}>
        <PageLink to={`/account/users/edit/${username}`}>
          <OGOnlyWrapper as="strong">{name}</OGOnlyWrapper>
        </PageLink>
      </div>

      <div className={styles.Email}>
        <OGOnlyWrapper as="em">{email}</OGOnlyWrapper>
      </div>
    </Fragment>
  );
};

export default User;
